var $5e997db6ea0d10f6$exports = {};
$5e997db6ea0d10f6$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farvev\xe6lger`,
    "colorSwatch": `farvepr\xf8ve`,
    "transparent": `gennemsigtig`,
    "twoDimensionalSlider": `2D-skyder`
};


export {$5e997db6ea0d10f6$exports as default};
//# sourceMappingURL=da-DK.module.js.map
